import tagTester from './_tagTester.js';

export default tagTester('String');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isString.js
// module id = tgw4
// module chunks = 0